import Repository from '@/api/core'
import queryString from 'query-string'

const submissionUrl = process.env.VUE_APP_API_CODECOMBAT_INTEGRATE + '/submission'
const leaderBoardUrl = process.env.VUE_APP_API_CODECOMBAT_INTEGRATE + '/leaderboard'

const fetchOneSubmission = id => Repository(submissionUrl).fetchOne(id)
const updateValidStateOfLevel = (id, data) => Repository(submissionUrl + '/validate-level').update(id, data)
const fetchSubmissionLogs = (id, params) => Repository(submissionUrl + '-logs/' + id).fetch(params)
const fetchSubmissions = params => {
  const query = queryString.stringify(params)
  return Repository(submissionUrl + `?${query}`).fetch()
}
const countSubmissions = params => {
  const query = queryString.stringify(params)
  return Repository(submissionUrl + `/count?${query}`).fetch()
}

const fetchWithRank = params => Repository(leaderBoardUrl + '/ranks').fetch(params)
const searchWithRank = params => Repository(leaderBoardUrl + '/search').fetch(params)
const count = params => Repository(leaderBoardUrl + '/count').fetch(params)

export default {
  fetchOneSubmission,
  updateValidStateOfLevel,
  fetchSubmissionLogs,
  fetchSubmissions,
  countSubmissions,
  //
  fetchWithRank,
  searchWithRank,
  count,
}
